import { APIInstance } from 'config';
import { API } from 'constants/apiEndpoints';
import { RESPONSE_TYPE, UPLOAD_RESPONSE, UPLOAD_URL_PAYLOAD } from 'models';

export const uploadAPIs = {
  uploadFile: (data: FormData) => {
    return APIInstance.post<RESPONSE_TYPE<UPLOAD_RESPONSE>>(
      API.UPLOAD.UPLOAD_FILE,
      data,
    );
  },
  getPresignedUrl: (params: UPLOAD_URL_PAYLOAD) => {
    return APIInstance.get<RESPONSE_TYPE<UPLOAD_RESPONSE>>(
      API.UPLOAD.GET_PRESIGNED_URL,
      { params },
    );
  },
  uploadByUrl: (data: UPLOAD_URL_PAYLOAD) => {
    return APIInstance.post<RESPONSE_TYPE<string>>(API.UPLOAD.UPLOAD_URL, data);
  },
  createServiceAgreement: (data: { parent_id: string; s3_url: string }) => {
    return APIInstance.post<RESPONSE_TYPE<boolean>>(
      API.SERVICE_AGREEMENTS.CREATE,
      data,
    );
  },
};
